import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';

const WINS = [
  { company: 'Riskthinking', amount: '$920,846', label: 'R&D grants', quote: 'Upgraded helped us secure our first major grant. The AI found opportunities we would have missed and drafted applications in hours instead of weeks.', name: 'Ron Dembo', role: 'Founder & CEO' },
  { company: 'Deeleeo', amount: '$178,846', label: 'Marketing + R&D grant', quote: 'Upgraded feels like an extension of our team, not just a contractor. They have saved us time, money, and stress, and helped us raise funding.', name: 'Jackson Payne', role: 'Founder & CEO' },
  { company: 'Parvis', amount: '$312,000', label: 'AI automation', quote: 'RevOps automation streamlined sales and billing from lead to cash. The process is now integrated and self-optimizing.', name: 'Scott Spence', role: 'Head of Growth' },
  { company: 'Covenant Group', amount: '$250,000', label: 'Government program', quote: 'The R&D tax credit discovery alone paid for Upgraded 10x over.', name: 'Norm Trainor', role: 'President & CEO' },
  { company: 'Provance', amount: '$407,301', label: 'R&D grants', quote: 'We consolidated 12 tools down to 4. Upgraded showed us exactly where we were overpaying.', name: 'Kelly Moodie', role: 'CEO' },
  { company: 'Tekside', amount: '$127,000', label: 'Software savings', quote: 'We were paying for tools we barely used. The analysis saved us six figures.', name: 'Geoff Linton', role: 'Founder & CEO' },
];

export default function ClientsWinningPage() {
  return (
    <MarketingShell
      title="Our clients are winning"
      description="Hear from companies who unlocked grants, savings, and AI operating leverage."
    >
      <ul className="grid gap-4 sm:grid-cols-2">
        {WINS.map((win) => (
          <li key={win.company} className="rounded-xl border border-gray-100 bg-white p-6">
            <p className="text-lg font-semibold text-gray-900">{win.amount}</p>
            <p className="mt-1 text-xs font-medium uppercase tracking-wide text-gray-500">{win.label}</p>
            <p className="mt-3 text-sm text-gray-600">{win.quote}</p>
            <p className="mt-4 text-sm font-medium text-gray-900">{win.name}</p>
            <p className="text-sm text-gray-500">{win.role}, {win.company}</p>
          </li>
        ))}
      </ul>
      <Link
        to="/wall-of-client-success"
        className="mt-6 inline-flex text-sm font-medium text-gray-900 hover:text-gray-700"
      >
        See live client results
      </Link>
    </MarketingShell>
  );
}
